export default [
  {
    text: "Intrebari frecvente",
  },
  {
    text: "Acte necesare ITP",
  },
  {
    text: "Istorie",
  },
  {
    text: "Ajutor",
  },
]
